import React from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import {
   Button,
   ImageCard,
   ImageMatchButton,
   ImageMatchModal,
   ImageViewer,
   Svg,
   UploadItemImageButton,
} from '../..'

import { ImagesProps } from './types'
import * as styles from './styles.module.scss'

const Images = ({
   isReadonly,
   onDragEnd,
   itemImages,
   removeItemImage,
   imageLimitReached,
   matchedImages,
   uploadImageDisabled,
   onImageUpload,
   allowViewGallery,
   handleViewGalleryClick,
   viewGalleryTooltip,
   openImageGallery,
   setOpenImageGallery,
   imagesForGallery,
   allowImageMatch,
   imageMatchIsTertiary,
   imageMatchIsDisabled,
   imageMatchTooltip,
   handleImageMatchClick,
   imageMatchModalOpen,
   setImageMatchModalOpen,
   isImageMatchSuccess,
   imageMatchErrorMessage,
   handleImageSelection,
   handleAddMatchedImages,
   maxAllowedImages,
}: ImagesProps) => {
   return (
      <div className={styles.columns}>
         <div
            className={styles.imagesColumn}
            style={{
               pointerEvents: isReadonly ? 'none' : 'auto',
            }}
         >
            <DragDropContext onDragEnd={onDragEnd}>
               <Droppable droppableId="droppable" direction="horizontal">
                  {(provided, _snapshot) => (
                     <div
                        ref={provided.innerRef}
                        className={styles.draggableImages}
                        {...provided.droppableProps}
                     >
                        {itemImages.map((img, index) => {
                           const handleRemoveImage = () =>
                              removeItemImage(img.Id, index)
                           return (
                              <Draggable
                                 key={img.Id}
                                 draggableId={img.Id}
                                 index={index}
                                 isDragDisabled={isReadonly}
                              >
                                 {(provided, _snapshot) => (
                                    <div
                                       ref={provided.innerRef}
                                       {...provided.draggableProps}
                                       {...provided.dragHandleProps}
                                    >
                                       <ImageCard
                                          alt={img.content}
                                          src={img.FullUrl}
                                          isPrimaryImage={index === 0}
                                          isMatchedImage={
                                             img.IsMatchedImage ||
                                             img.AIImageId > 0
                                          }
                                          onDeleteClick={handleRemoveImage}
                                       />
                                    </div>
                                 )}
                              </Draggable>
                           )
                        })}
                        {provided.placeholder}
                        {!imageLimitReached && !isReadonly && (
                           <UploadItemImageButton
                              isDisabled={uploadImageDisabled}
                              onImageUpload={onImageUpload}
                           />
                        )}
                     </div>
                  )}
               </Droppable>
            </DragDropContext>
         </div>
         <div className={styles.actionButtonsColumn}>
            <Button
               type="button"
               variant={!allowViewGallery ? 'tertiary' : 'primary'}
               preserveText
               onClick={handleViewGalleryClick}
               disabled={!allowViewGallery}
               title={viewGalleryTooltip}
               icon={
                  <Svg
                     id="view"
                     fill={!allowViewGallery ? '#373737' : 'white'}
                  />
               }
            >
               View Gallery
            </Button>
            {allowViewGallery && (
               <ImageViewer
                  open={openImageGallery}
                  setOpen={setOpenImageGallery}
                  images={imagesForGallery}
               />
            )}
            {allowImageMatch && (
               <>
                  <ImageMatchButton
                     isTertiary={imageMatchIsTertiary}
                     disabled={imageMatchIsDisabled}
                     tooltip={imageMatchTooltip}
                     onClick={handleImageMatchClick}
                  />
                  <ImageMatchModal
                     isOpen={imageMatchModalOpen}
                     handleClose={() => setImageMatchModalOpen(false)}
                     isSuccess={isImageMatchSuccess}
                     errorMessage={imageMatchErrorMessage}
                     matchedImages={matchedImages}
                     handleImageSelection={handleImageSelection}
                     handleAddMatchedImages={handleAddMatchedImages}
                     maxAllowedImages={maxAllowedImages}
                  />
               </>
            )}
         </div>
      </div>
   )
}

export default Images
